<template>
	<v-dialog
		v-model="internalDialog"
		persistent
		scrollable
		max-width="820"
		content-class="policy-dialog"
		overlay-opacity="0.85"
		overlay-color="#000000"
		transition="dialog-bottom-transition"
	>
		<v-card class="policy-card">
			<v-toolbar dense flat color="#2D4B95" dark class="policy-toolbar">
				<v-icon left size="20">mdi-shield-lock-outline</v-icon>
				<v-toolbar-title>Política de Privacidad - 20 de julio de 2026</v-toolbar-title>
			</v-toolbar>

			<div class="policy-notice">
				<div class="policy-notice-content">
					<div class="notice-icon d-flex align-center mb-1" style="gap: 5px;">
						<v-icon size="18" color="#7C5B00" class="notice-icon">mdi-alert-circle-outline</v-icon>
						<div class="notice-title">Aceptación obligatoria — Ley 21.719 de Protección de Datos Personales</div>
					</div>
					<div class="notice-body">
						<div class="notice-text">
							LaOT trata tus datos personales como <strong>encargado del tratamiento</strong> por cuenta de tu empresa.
							La ley exige que seas informado y que aceptes la Política de Privacidad de forma
							<strong>expresa y verificable</strong> antes de acceder al sistema.
							<strong>Sin esta aceptación no es posible utilizar la plataforma.</strong>
						</div>
					</div>
				</div>
			</div>

			<v-card-text class="policy-body" ref="policyBody">
				<div class="container">
					<section class="section" id="responsable">
						<h2>1. Responsable del tratamiento</h2>
						<p><strong>LAOT.CL PANEL DE CONTROL SpA</strong>, RUT <strong>77.135.065-8</strong>, domicilio en MANUEL OLEGARIO SOTO, EL OLIVAR 199, RANCAGUA, Región del Libertador General Bernardo O'Higgins.</p>
						<p><strong>Contacto para datos personales:</strong> <a href="mailto:mcereceda@laot.cl">mcereceda@laot.cl</a> · <strong>Responsable de datos:</strong> Cristian Neira.</p>
						<p class="muted">Sobre nuestro rol: LaOT es una plataforma de gestión de proyectos. En la mayoría de los flujos actamos como <strong>encargado del tratamiento</strong> por cuenta de la empresa-cliente que contrata el servicio. Para los datos de facturación y soporte propios, actuamos como <strong>responsable</strong>.</p>
					</section>

					<section class="section" id="datos">
						<h2>2. Qué datos tratamos</h2>
						<div class="table-wrap">
							<table class="md-table">
								<thead>
									<tr>
										<th>Categoría</th>
										<th>Datos</th>
										<th>Quién los entrega</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>Cuenta de usuario</td>
										<td>Nombre, correo electrónico, contraseña (almacenada con hash bcrypt), teléfono, dirección, foto de perfil</td>
										<td>El propio usuario o la empresa-cliente</td>
									</tr>
									<tr>
										<td>Proyecto</td>
										<td>Nombre del proyecto, dirección, coordenadas geográficas (lat/lng), documentos adjuntos, comentarios</td>
										<td>La empresa-cliente y sus usuarios</td>
									</tr>
									<tr>
										<td>Comunicaciones</td>
										<td>Preferencias de notificación, correos enviados a través de la plataforma</td>
										<td>El usuario</td>
									</tr>
									<tr>
										<td>Reuniones</td>
										<td>Lugar/dirección de reunión, participantes (nombre y correo), fecha</td>
										<td>El usuario</td>
									</tr>
									<tr>
										<td>Firma electrónica</td>
										<td>PIN de firma (almacenado con hash bcrypt)</td>
										<td>El usuario</td>
									</tr>
									<tr>
										<td>Facturación</td>
										<td>Nombre y RUT de empresa-cliente, datos de pago</td>
										<td>La empresa-cliente</td>
									</tr>
								</tbody>
							</table>
						</div>
						<p><strong>No tratamos datos sensibles</strong> (salud, biométricos, origen étnico, opiniones políticas, datos de menores de edad) como parte del servicio estándar.</p>
					</section>

					<section class="section" id="finalidad">
						<h2>3. Finalidad y base de licitud</h2>
						<div class="table-wrap">
							<table class="md-table">
								<thead>
									<tr><th>Finalidad</th><th>Base de licitud</th></tr>
								</thead>
								<tbody>
									<tr><td>Prestación del servicio de gestión de proyectos / cuenta de usuario</td><td>Ejecución de contrato (Art. 13 lit. b, Ley 21.719)</td></tr>
									<tr><td>Notificaciones y comunicaciones relacionadas con el servicio</td><td>Ejecución de contrato / interés legítimo</td></tr>
									<tr><td>Facturación y cumplimiento tributario</td><td>Obligación legal (Código Tributario)</td></tr>
									<tr><td>Seguridad, calidad del servicio y logs de errores</td><td>Interés legítimo del responsable/encargado</td></tr>
									<tr><td>Firma electrónica de documentos dentro de la plataforma</td><td>Ejecución de contrato</td></tr>
								</tbody>
							</table>
						</div>
					</section>

					<section class="section" id="compartimos">
						<h2>4. Con quién compartimos los datos</h2>
						<p>Usamos los siguientes <strong>proveedores que actúan como sub-encargados</strong>:</p>
						<div class="table-wrap">
							<table class="md-table">
								<thead><tr><th>Proveedor</th><th>País</th><th>Servicio</th><th>Mecanismo de transferencia</th></tr></thead>
								<tbody>
									<tr><td>Amazon Web Services (AWS)</td><td>EE.UU.</td><td>Almacenamiento de archivos (S3), correo (SES)</td><td>Cláusulas Contractuales Modelo (Min. Economía, D.O. 19-12-2025)</td></tr>
									<tr><td>Google LLC (Firebase)</td><td>EE.UU.</td><td>Notificaciones push y autenticación</td><td>Cláusulas Contractuales Modelo</td></tr>
									<tr><td>Mailgun / Sinch Email</td><td>EE.UU.</td><td>Envío de correos transaccionales</td><td>Cláusulas Contractuales Modelo</td></tr>
									<tr><td>Autodesk Inc. (Forge/APS)</td><td>EE.UU.</td><td>Visualización de modelos BIM</td><td>Cláusulas Contractuales Modelo</td></tr>
								</tbody>
							</table>
						</div>
						<p><strong>No vendemos, cedemos ni compartimos datos personales</strong> con terceros con fines comerciales propios.</p>
						<p>Las transferencias a proveedores en EE.UU. se amparan en las <strong>Cláusulas Contractuales Modelo aprobadas por el Ministerio de Economía</strong> (Resolución RAEX202503748, Diario Oficial 19-12-2025), conforme al Art. 27 de la Ley 21.719.</p>
					</section>

					<section class="section" id="retencion">
						<h2>5. Por cuánto tiempo</h2>
						<div class="table-wrap">
							<table class="md-table">
								<thead><tr><th>Dato</th><th>Plazo de retención</th></tr></thead>
								<tbody>
									<tr><td>Datos de cuenta y proyecto</td><td>Mientras dure la relación contractual, más <strong>3 años</strong> tras la baja de cuenta</td></tr>
									<tr><td>Datos de facturación</td><td><strong>7 años</strong> (obligación tributaria, Art. 200 Código Tributario)</td></tr>
									<tr><td>Logs de aplicación (seguridad)</td><td><strong>1 año</strong></td></tr>
									<tr><td>PIN de firma electrónica</td><td>Hasta su revocación, más 3 años</td></tr>
								</tbody>
							</table>
						</div>
						<p>Vencido el plazo, los datos se eliminan o anonimizan de forma segura.</p>
					</section>

					<section class="section" id="tus-derechos">
						<h2>6. Tus derechos</h2>
						<ul>
							<li><strong>Acceso:</strong> obtener una copia de tus datos (gratuito al menos una vez por trimestre).</li>
							<li><strong>Rectificación:</strong> corregir datos inexactos.</li>
							<li><strong>Supresión:</strong> solicitar el borrado de tus datos (siempre que no exista obligación legal de conservarlos).</li>
							<li><strong>Oposición:</strong> oponerte al tratamiento para una finalidad específica.</li>
							<li><strong>Portabilidad:</strong> recibir tus datos en formato estructurado (JSON/CSV).</li>
							<li><strong>Bloqueo:</strong> suspender temporalmente el tratamiento mientras se resuelve una disputa.</li>
							<li><strong>Revocación del consentimiento:</strong> cuando el tratamiento se base en consentimiento, puedes retirarlo en cualquier momento sin coste.</li>
						</ul>
						<p><strong>Cómo ejercerlos:</strong> escríbenos a <a href="mailto:mcereceda@laot.cl">mcereceda@laot.cl</a> indicando el derecho que deseas ejercer y tu identidad. Respondemos en <strong>30 días corridos</strong> (prorrogables una sola vez por 30 días más). La rectificación, supresión y oposición son <strong>siempre gratuitas</strong>.</p>
					</section>

					<section class="section" id="automatizadas">
						<h2>7. Decisiones automatizadas</h2>
						<p>LaOT <strong>no toma decisiones automatizadas con efectos jurídicos o significativos</strong> sobre los titulares. No realizamos perfilado con fines de segmentación comercial propia.</p>
					</section>

					<section class="section" id="seguridad">
						<h2>8. Seguridad</h2>
						<p>Aplicamos medidas técnicas y organizativas proporcionales al riesgo:</p>
						<ul>
							<li>Cifrado en tránsito (TLS/HTTPS).</li>
							<li>Contraseñas almacenadas con hashing bcrypt.</li>
							<li>Segregación de datos por empresa (company_id).</li>
							<li>Control de acceso por roles y capacidades.</li>
							<li>Logs de actividad de la aplicación.</li>
						</ul>
					</section>

					<section class="section" id="cambios">
						<h2>9. Cambios</h2>
						<p>Podemos actualizar esta política. Publicaremos la versión vigente con su fecha en la plataforma. Ante cambios relevantes, notificaremos por correo.</p>
					</section>

					<section class="section" id="reclamos">
						<h2>10. Reclamos</h2>
						<p>Si consideras que tus derechos han sido vulnerados, puedes reclamar ante la <strong>Agencia de Protección de Datos Personales de Chile</strong> una vez que esta entre en funcionamiento (previsto dic-2026), o ante los Tribunales de Justicia.</p>
					</section>
				</div>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions class="actions actions-buttons">
				<div class="consent-box">
					<v-checkbox
						v-model="localConsent"
						:label="checkboxLabel"
						hide-details
						color="#2D4B95"
						class="consent-checkbox"
					></v-checkbox>
				</div>
				<v-spacer />
				<v-btn
					:color="localConsent ? '#2D4B95' : undefined"
					:dark="localConsent"
					depressed
					large
					class="accept-btn"
					:class="{ 'accept-btn--disabled': !localConsent }"
					:disabled="!localConsent"
					@click="accept"
				>
					Aceptar y continuar
					<v-icon right size="18" :color="localConsent ? undefined : '#8b93a7'">mdi-arrow-right</v-icon>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { setComplianceConsent } from '@/helpers/api/user'

export default {
	name: 'UserComplianceConsentAcceptance',
	props: {
		value: { type: Boolean, default: false },
		consent: { type: Boolean, default: false }
	},
	data() {
		return {
			localConsent: this.consent,
			internalDialog: true
		}
	},
	computed: {
		checkboxLabel() {
			return 'He leído y acepto la Política de Privacidad y autorizo el tratamiento de mis datos.'
		}
	},
	watch: {
		consent(newVal) { this.localConsent = newVal }
	},
	methods: {
		async accept() {
			const compliance = await setComplianceConsent({ consent_declaration: this.localConsent })
			if(compliance.code == 200){
				this.$store.userStore.dispatch('getUserInfo')
        this.$store.globalStore.dispatch('addMessage', {
          message: 'Políticas de privacidad aceptadas.',
          title: 'Políticas de privacidad',
          created: new Date(),
          type: 'success',
          icon: 'mdi-check-circle',
          color: '#3EBFA3',
        })
			}
		}
	}
}
</script>

<style>
/* v-dialog content wrapper: rounded corners + constrained height so the
   overlay is visible around it and the page behind cannot be interacted with */
.policy-dialog {
	border-radius: 16px;
	max-height: 88vh;
}
</style>

<style scoped>
.policy-card {
	display: flex;
	flex-direction: column;
	max-height: 88vh;
	border-radius: 16px;
	overflow: hidden;
}
.policy-toolbar {
	flex: 0 0 auto;
}
.policy-notice {
	flex: 0 0 auto;
	background: #FFF8E1;
	border-bottom: 1px solid #F1DFA0;
	padding: 12px 20px;
}
.notice-title {
	font-size: 13px;
	font-weight: 700;
	color: #7C5B00;
}
.notice-text {
	font-size: 12.5px;
	line-height: 1.5;
	color: #6b5300;
}
.policy-body {
	padding: 20px;
	overflow-y: auto;
	flex: 1 1 auto;
}
.policy-body .container { max-width: 980px; margin: 0 auto; }
.policy-body h2 {
	margin-top: 8px;
	margin-bottom: 8px;
	font-size: 17px;
	color: #2D4B95;
}
.policy-body .muted { color: rgba(0, 0, 0, 0.6); }
.md-table { width: 100%; border-collapse: collapse; margin: 8px 0 12px 0; }
.md-table th, .md-table td { border: 1px solid rgba(0,0,0,0.08); padding: 10px; text-align: left; vertical-align: top }
.md-table thead th { background: #f7f8fa }
.disclaimer { margin-top: 16px; padding-top: 12px; border-top: 1px solid rgba(0,0,0,0.06); color: rgba(0,0,0,0.85); font-size: 14px; }

.actions {
	flex: 0 0 auto;
	padding: 10px 20px;
}
.actions-buttons {
	padding-top: 10px;
	padding-bottom: 18px;
	align-items: center;
	flex-wrap: wrap;
	gap: 12px;
}
.accept-btn {
	flex: 0 0 auto;
}
.consent-box {
	flex: 1 1 320px;
	display: flex;
	align-items: center;
	background: #EEF2FC;
	border: 1.5px solid #C7D3F2;
	border-radius: 10px;
	padding: 10px 14px;
}
.consent-checkbox {
	margin-top: 0;
}
.consent-checkbox ::v-deep .v-label {
	font-size: 14.5px;
	font-weight: 600;
	line-height: 1.35;
	color: #1E2B57;
}
.consent-checkbox ::v-deep .v-icon {
	font-size: 26px;
	color: #2D4B95 !important;
}
.accept-btn {
	border-radius: 10px;
	text-transform: none;
	font-weight: 600;
	letter-spacing: 0;
	padding: 0 24px;
	box-shadow: 0 4px 12px rgba(45, 75, 149, 0.28);
}
.accept-btn--disabled {
	background: #E4E7EF !important;
	color: #8b93a7 !important;
	box-shadow: none;
	opacity: 1 !important;
}

@media (max-width: 600px) {
	.policy-dialog { max-height: 94vh; }
	.policy-card { max-height: 94vh; }
	.policy-body { padding: 14px }
	.actions-buttons { padding-bottom: 14px; }
}
</style>